import clsx from 'clsx';
import { Info } from 'lucide-react';
import React from 'react';
import { Order } from 'utils/list-sort';
import Tooltip from '../tooltip';
import { HeadCell as HeadCellType } from './list';

import { Box, TableCell, TableSortLabel } from '@mui/material';

const PREFIX = 'HeadCell';
const classes = {
  tableHeadCell: `${PREFIX}-tableHeadCell`,
  autoWidth: `${PREFIX}-autoWidth`,
  fullWidth: `${PREFIX}-fullWidth`,
  sticky: `${PREFIX}-sticky`,
};

type Props = {
  headCell: HeadCellType;
  orderBy?: string;
  order?: Order;
  handleRequestSort?: (property: string) => void;
  sort?: React.Dispatch<React.SetStateAction<any>>;
};

const HeadCell: React.FC<Props> = ({ headCell, orderBy, order, handleRequestSort, sort }) => {
  const headCellClasses = clsx(classes.tableHeadCell, {
    [classes.sticky]: headCell.sticky,
    [classes.autoWidth]: headCell.autoWidth,
    [classes.fullWidth]: headCell.fullWidth,
  });

  return headCell.hide ? null : (
    <TableCell
      key={headCell.id}
      align={headCell.align ?? 'left'}
      sx={headCell.sx}
      colSpan={headCell.colSpan || 1}
      className={headCellClasses}>
      {sort && !!headCell.label && !headCell.disableSort ? (
        <TableSortLabel
          {...headCell.sortLabelProps}
          active={orderBy === headCell.id}
          direction={orderBy === headCell.id ? order : 'asc'}
          onClick={() => !!handleRequestSort && handleRequestSort(headCell.id)}>
          {!!headCell.info && (
            <Tooltip title={headCell.info}>
              <Info size={18} style={{ marginLeft: 4, marginRight: 4 }} />
            </Tooltip>
          )}
          {headCell.label}
        </TableSortLabel>
      ) : (
        <Box display={'inline-flex'} alignItems={'flex-end'}>
          {headCell.info && (
            <Tooltip title={headCell.info}>
              <Info size={18} style={{ marginLeft: 4, marginRight: 4 }} />
            </Tooltip>
          )}
          {headCell.label}
        </Box>
      )}
    </TableCell>
  );
};

export default React.memo(HeadCell);
